import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export const LanguageToggle: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="fixed top-4 right-4 z-50">
      <button
        onClick={() => setLanguage(language === 'en' ? 'pt' : 'en')}
        className="bg-white/10 backdrop-blur-sm border border-purple-500/30 rounded-full px-4 py-2 text-white hover:bg-white/20 transition-all duration-300 flex items-center gap-2"
        aria-label="Toggle language"
      >
        <span className="text-lg">
          {language === 'en' ? '🇺🇸' : '🇧🇷'}
        </span>
        <span className="font-medium">
          {language === 'en' ? 'EN' : 'PT'}
        </span>
        <span className="text-xs opacity-70">
          →
        </span>
        <span className="text-lg">
          {language === 'en' ? '🇧🇷' : '🇺🇸'}
        </span>
      </button>
    </div>
  );
};